import { render, staticRenderFns } from "./DanhSachLogTrongApp.vue?vue&type=template&id=45364aa9&"
import script from "./DanhSachLogTrongApp.vue?vue&type=script&lang=js&"
export * from "./DanhSachLogTrongApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports